<app-mobile-filter (clearFilters)="onClearFilters()" (close)="onCloseModal()">
  <ng-container content>
    <!-- filtr po Statusie -->
    <ion-col class="ion-no-padding" size="12">
      <ion-item lines="full" (click)="showStatus = !showStatus">
        <ion-label>{{ "REPORT.STATUS" | translate }}</ion-label>
        <ion-icon
          slot="end"
          name="chevron-down"
          [@toggleRotate]="showStatus ? 'active' : 'inactive'"
        ></ion-icon>
      </ion-item>
    </ion-col>

    <ion-col
      class="ion-no-padding overflow-hidden"
      size="12"
      [@toggleHeight]="showStatus ? 'active' : 'inactive'"
    >
      <ion-radio-group
        (ionChange)="onFilterStatus($event)"
        [value]="reportService.reportFilter.statusValue"
      >
        <ion-item lines="none">
          <ion-radio slot="start" value="null"></ion-radio>
          <ion-label>{{ "ALL" | translate }}</ion-label>
        </ion-item>
        <ng-container *ngIf="page === 'report'">
          <ion-item
            *ngFor="let status of dictionaryServ.reportStatusValues"
            lines="none"
          >
            <ion-radio slot="start" [value]="status.value + ''"></ion-radio>
            <ion-label>{{ status.key }}</ion-label>
          </ion-item>
        </ng-container>

        <ng-container *ngIf="page === 'report-task'">
          <ion-item
            *ngFor="let status of dictionaryServ.reportTaskStatusValues"
            lines="none"
          >
            <ion-radio slot="start" [value]="status.value + ''"></ion-radio>
            <ion-label>{{ status.key }}</ion-label>
          </ion-item>
        </ng-container>
      </ion-radio-group>
    </ion-col>

    <!-- filtr po Priorytecie -->
    <ion-col class="ion-no-padding" size="12">
      <ion-item lines="full" (click)="showPriority = !showPriority">
        <ion-label>Priorytet</ion-label>
        <ion-icon
          slot="end"
          name="chevron-down"
          [@toggleRotate]="showPriority ? 'active' : 'inactive'"
        ></ion-icon>
      </ion-item>
    </ion-col>

    <ion-col
      class="ion-no-padding overflow-hidden"
      size="12"
      [@toggleHeight]="showPriority ? 'active' : 'inactive'"
    >
      <ion-radio-group
        (ionChange)="onFilterPriority($event)"
        [value]="reportService.reportFilter.priorityValue"
      >
        <ion-item lines="none">
          <ion-radio slot="start" value="null"></ion-radio>
          <ion-label>{{ "ALL" | translate }}</ion-label>
        </ion-item>
        <ion-item
          *ngFor="let priority of dictionaryServ.reportPriorityValues"
          lines="none"
        >
          <ion-radio slot="start" [value]="priority.value + ''"></ion-radio>
          <ion-label>{{ priority.key }}</ion-label>
        </ion-item>
      </ion-radio-group>
    </ion-col>
  </ng-container>

  <ng-container button>
    <ng-container *ngIf="reportService.filterDetailsShowLoader">
      <img src="./assets/loading.svg" class="parking-filter-modal__loader" />
    </ng-container>

    <ng-container
      *ngIf="page === 'report' && !reportService.filterDetailsShowLoader"
    >
      {{ reportService.reports.length }}
    </ng-container>
    <ng-container
      *ngIf="page === 'report-task' && !reportService.filterDetailsShowLoader"
    >
      {{ reportTaskService.reportTasks.length }}
    </ng-container>
  </ng-container>
</app-mobile-filter>
